import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { middletownNYConfig } from "./data";

export default function MiddletownNYPage() {
  return <CityPageTemplate config={middletownNYConfig} />;
}